/* You must register this file at "website\src\i18n\fa-ir" */

export default {
    /* Global Vocabulary */


    /* Module special vocabulary */
    trades: {
        menu: {
            index: 'معاملات',
            create: 'جدید',
            list: 'معاملات'
        },
        table_titles: {
            id: 'شناسه',
            exchange: 'صرافی',
            role: 'نقش',
            side: 'جهت',
            price: 'قیمت',
            amount: 'مقدار',
            fee: 'کارمزد',
            total: 'مجموع',
            status: 'وضعیت',
            created_at: 'زمان',
            setting: 'ویرایش / حذف',
        },
        edit: 'ویرایش معامله'
    }
}
